import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client'

const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT || 'http://localhost:5032/graphql'

const getToken = () => {
  const token = window.localStorage.getItem('token')

  if (token) {
    // Remove double quotes if present
    const cleanToken = token.replace(/^"|"$/g, '')
    return `Bearer ${cleanToken}`
  }
  return 'Bearer null'
}

// Enhanced cache configuration
const cache = new InMemoryCache({
  // Cache policy to ensure fresh data on route changes
  typePolicies: {
    Query: {
      fields: {
        // Configure field policies for better cache management
        getAllStylesAdmin: {
          merge: false, // Don't merge arrays, replace them
        },
        getAllPromptsAdmin: {
          merge: false,
        },
        getAllSectionsAdmin: {
          merge: false,
        },
        getAllTagsAdmin: {
          merge: false,
        },
        getAllUsers: {
          merge: false,
        },
        getAllSetsAdmin: {
          merge: false,
        },
        getAllModelsAdmin: {
          merge: false,
        },
        getAllCategoriesAdmin: {
          merge: false,
        },
      },
    },
  },
})

const client = new ApolloClient({
  uri: GRAPHQL_ENDPOINT,
  cache,
  headers: { Authorization: getToken() },
  // Default fetch policy for better cache behavior
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
)
